import React from "react";
import { ArrowLeft } from "react-feather";
import { useHistory } from "react-router-dom";

export default function ArrowBack() {
  const history = useHistory();

  const handleBack = () => {
    return history.goBack();
  };

  return (
    <div className="w-full text-start">
      <ArrowLeft color="gray" size={30} className="mt-4 cursor-pointer" onClick={handleBack} />
    </div>
  );
}
